import type { ReactNode } from 'react';

export const symbol_counter_0: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480.27-80q-82.74 0-155.5-31.5Q252-143 197.5-197.5t-86-127.34Q80-397.68 80-480.5t31.5-155.66Q143-709 197.5-763t127.34-85.5Q397.68-880 480.5-880t155.66 31.5Q709-817 763-763t85.5 127Q880-563 880-480.27q0 82.74-31.5 155.5Q817-252 763-197.68q-54 54.31-127 86Q563-80 480.27-80Zm.23-60Q622-140 721-239.5t99-241Q820-622 721.19-721T480-820q-141 0-240.5 98.81T140-480q0 141 99.5 240.5t241 99.5Zm-.5-340Zm-55 213h110q24.75 0 42.38-17.63Q595-302.25 595-327v-307q0-24.75-17.62-42.38Q559.75-694 535-694H425q-24.75 0-42.37 17.62Q365-658.75 365-634v307q0 24.75 17.63 42.37Q400.25-267 425-267Zm0-367h110v307H425v-307Z"
		/>
	</svg>
);
